import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconExpense = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.0625 0.9375H0.9375C0.375 0.9375 0 1.3125 0 1.875C0 2.4375 0.375 2.8125 0.9375 2.8125H1.875V13.125C1.875 13.6875 2.25 14.0625 2.8125 14.0625H8.4375V2.8125H10.3125V14.0625H12.1875C12.75 14.0625 13.125 13.6875 13.125 13.125V2.8125H14.0625C14.625 2.8125 15 2.4375 15 1.875C15 1.3125 14.625 0.9375 14.0625 0.9375ZM5.625 12.1875H4.6875V10.3125H5.625V12.1875ZM5.625 4.6875H4.6875V2.8125H5.625V4.6875Z",
		fill: "currentColor"
	})
});
export default SvgIconExpense;
